module.exports = __webpack_public_path__ + "img/bybit_4.527e597d.png";